export default __webpack_public_path__ + "static/illustration-action.url-375c1716770cb9c1f9c9f4f19db69366.svg";